<template>
  <div class="row scrollable detail-event bg-white">
    <loading name="load event detail" class="col">
      <div class="col mt-3" v-if="event">
        <h3 v-html="event ? event.name : ''"></h3>
        <div><strong>{{$t('fields.Theme')}}:</strong> {{event.theme}}</div>
        <small><strong>{{$t('fields.FromTo')}}:</strong> {{event.start_date}} -
          {{event.end_date}}</small>
        <span class="badge badge-warning register-token-badge" v-if="event.registrationToken">
                    <span class="registered-text">{{$t('fields.RegistrationToken')}}: </span>
                     <span class="badge badge-light"> {{event.registrationToken}}</span>
                </span>
        <span class="badge badge-success registered-badge">
                    <span class="registered-text">{{$t('fields.Registered')}} </span>
                    <span class="badge badge-light">{{event.participantCount}}</span>
                </span>
        <router-link class="fas fa-pencil-alt edit hand primary-color"
                     :to="'/admin/events/' + event.id + '/edit'"></router-link>
        <hr/>
        <div class="event-body row">
          <div class="col col-md-6">
            <label>{{$t('fields.BusIn')}}</label>
            <div class="mb-2">
              <span v-for="time in event.busInTimes" :key="'in-'+time.time">{{time.time}}, </span>
            </div>
          </div>
          <div class="col col-md-6">
            <label>{{$t('fields.BusOut')}}</label>
            <div class="mb-2">
              <span v-for="time in event.busOutTimes" :key="'out-'+time.time">{{time.time}}, </span>
            </div>
          </div>
          <div class="col col-md-6">
            <label>{{$t('fields.VolunteerTypes')}}</label>
            <div class="mb-2">
              <span v-for="vol in event.volunteerTypes" :key="'vol-'+vol.id"
                    v-html="vol ? vol.name + ', ': ''"></span>
            </div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.StartDate')}}</label>
            <div>{{event.start_date}}</div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.EndDate')}}</label>
            <div>{{event.end_date}}</div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.StartRegistrationDate')}}</label>
            <div>{{event.start_registration}}</div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.EndRegistrationDate')}}</label>
            <div>{{event.end_registration}}</div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.EndVolunteerRegistrationDate')}}</label>
            <div>{{event.end_volunteer_registration}}</div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.PriceOptions')}}</label>
            <div v-for="price in event.prices" :key="price.id">
                            <span class="mb-2">
                                {{$t('fields.NeedPay')}}: {{price.need_pay}} &euro;
                            </span>
              <span class="mb-2">
                                {{$t('fields.Deposit')}}: {{price.deposit}} &euro;
                            </span>
              <span class="mb-2">
                                {{$t('fields.Desc')}}: {{price.description}}
                            </span>
            </div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.BusInCount')}}</label>
            <div class="row" v-for="bus in event.stats['bus-in']" :key="bus.transport_in">
              <div class="col-6">{{$t('fields.Count')}}: {{bus.count}}</div>
              <div class="col-6">{{bus.transport_in}}</div>
            </div>
          </div>
          <div class="col col-md-6 mb-2">
            <label>{{$t('fields.BusOutCount')}}</label>
            <div class="mb-2">
              {{event.stats['bus-out']}}
            </div>
          </div>
          <div class="w-100">
            <events-payment-log-upload-modal :event-id="eventId"/>
            <a class="btn btn-primary btn-sm float-right mr-2" target="_blank" :href="stats"><i class="mr-2 fas fa-file-download"></i>{{ $t('button.DownloadStats') }}</a>
          </div>
        </div>
      </div>
      <div v-else>
        Skus refreshnut ale pockat
      </div>
    </loading>
  </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import EventsPaymentLogUploadModal from "../../components/events/EventsPaymentLogUploadModal";
    import {API_ROOT} from "../../constants";

    export default {
        name: 'DetailEvent',
        components: {EventsPaymentLogUploadModal},
        created() {
            this.$wait.start('load event detail');
            const detail = this.detailEvent({
                eventId: this.eventId
            });
            const volunteerTypes = this.loadVolunteerTypes();

            Promise.all([detail, volunteerTypes])
                .then(() => {
                    this.$wait.end('load event detail');
                });
        },
        computed: {
            ...mapGetters(['getVolunteerTypes', 'token']),
            event() {
                return this.$store.state.admin.eventDetail[this.eventId];
            },
            eventId() {
                return this.$route.params.eventId;
            },
            stats() {
                return API_ROOT + '/secure/admin/events/' + this.eventId + '/stats?token=' + this.token
            }
        },
        methods: {
            ...mapActions(['loadVolunteerTypes', 'detailEvent']),
        }
    };
</script>

<style scoped>
  .registered-badge {
    position: absolute;
    right: 45px;
    top: 40px;
  }

  .register-token-badge {
    position: absolute;
    right: 45px;
    top: 70px;
  }

  .register-token-badge > .badge {
    font-size: 0.85rem;
    font-weight: bold;
  }

  .registered-badge > .badge {
    font-size: 0.8rem;
    font-weight: bold;
  }

  .registered-text {
    font-size: 14px;
  }

  .edit {
    position: absolute;
    top: 40px;
    right: 15px;
    font-size: 18px;
  }
</style>
